<template>
    <div>
        <v-toolbar flat color="secondary" dense class="mb-3" outlined elevation="1">
            <v-breadcrumbs class="ms-n6" :items="[{text: 'Financial Accounting'}, {text: 'Reports'} ,{text: 'Dimensions Report',}]" large/>
        </v-toolbar>
        <v-sheet elevation="1" >
            <v-toolbar
                flat
                color="secondary">
                <v-row>
                    <v-col cols="2">
                        <PDatePicker
                            label="From"
                            v-model="query.opening_date"
                            outlined
                            background-color="white"
                            hide
                            />
                    </v-col>
                    <v-col cols="2">
                        <PDatePicker
                            label="To"
                            v-model="query.closing_date"
                            background-color="white"
                            outlined
                            hide
                            />
                    </v-col>
                    <v-col cols="2">
                        <v-autocomplete
                            label="Dimension"
                            outlined
                            background-color="white"
                            single-line
                            dense
                            hide-details="auto"
                            v-model="query.dimension_id"
                            :items="dimensions"
                            item-text="name"
                            :loading="dimensionsLoading"
                            item-value="id"
                            @update:search-input="searchDimensions">
                        </v-autocomplete>
                    </v-col>
                    <v-col>
                        <v-btn depressed color="primary" @click="fetchReport" :loading="loading.data">
                            <v-icon left>mdi-magnify</v-icon>
                            search
                        </v-btn>
                    </v-col>
                </v-row>
            </v-toolbar>
            <v-divider></v-divider>
            <div class="pa-4">
                <div v-if="data.length > 0"> 
                    <v-treeview
                        item-key="account_id"
                        item-text="display_name"
                        :open="[]"
                        dense
                        activatable
                        open-on-click
                        :items="data">
                        <template v-slot:append="{ item }">
                            <tr>
                                <td class="tr_balance">{{formatNumber(item.total, decimal)}}</td>
                            </tr>
                        </template>
                    </v-treeview>
                </div>
                <div v-else-if="errors.length == 0" class="d-flex justify-center">
                    <v-icon>mdi-alert-circle-outline</v-icon>
                    <span class="ms-2">No Data, Please Search ...</span>
                </div>
                <div v-else class="d-flex justify-center">
                    <v-icon class="error--text">mdi-alert-circle-outline</v-icon>
                    <span class="ms-2 error--text">{{errors[0]}}</span>
                </div>
            </div>
        </v-sheet>
        <v-overlay v-model="loading.data">
            <v-sheet color="white" class="pa-4" width="300" elevation="1" rounded>
                <v-progress-linear indeterminate color="primary"/>
                <div class="primary--text text-center mt-2">Please Wait ...</div>
            </v-sheet>
        </v-overlay>
    </div>
</template>

<script>
import PDatePicker from './../../components/common/PDatePicker';
import { formatNumber } from 'accounting';
import { getDimensionsReport } from '../../services/ledger/reports';
import { searchDimensionByNameOrCode } from './../../services/ledger/dimension'
import moment from 'moment';

export default {
    name: "DimensionsReport",
    components: {PDatePicker},
    data() {
        return {
            query: {
                opening_date: moment().startOf("month").format("YYYY-MM-DD"),
                closing_date: moment().format("YYYY-MM-DD"),
                dimension_id: null
            },
            loading: {
                data: false
            },
            decimal: 2,
            data: [],
            errors: [],
            dimensions: [
                { id: null, name: "Without Dimension" }
            ],
            dimensionsLoading: false
        }
    },
    methods: {
        formatNumber,
        async fetchReport() {
            try {
                this.errors = [];
                this.loading.data = true;
                let resp = await getDimensionsReport(this.query);
                this.data = resp.data;
                this.loading.data = false;
            } catch (error) {
                this.loading.data = false;
                let message = error.response ? error.response.data.message : error;
                this.errors.push(message);
            }
        },
        searchDimensions(query) {
            this.dimensionsLoading = true;
            searchDimensionByNameOrCode({search: query, limit: 10}).then(response => {
                this.dimensions = Array.from(new Set([...this.dimensions, ...response.data]))
            }).finally(() => {
                this.dimensionsLoading = false;
            })
        }
    },
    created() {
        this.fetchReport();
    }
}
</script>

<style scoped>
    .tr_balance {
        width: 140px;
        text-align: left;
        font-size: 0.8em;
    }

    .tr_title {
        width: 140px;
        text-align: left;
        font-size: 13px;
    }
</style>